import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import { Wrapper, WrapperData } from 'modules/theme';
import { ControlLabel } from 'modules/theme';
import { ChartWrapper, FlexRow, InsightContent, InsightRow, InsightTitle } from '../styles/main';
import DashboardTileTheme from './DashboardTileTheme';
import { FiMessageSquare, FiPhone } from 'react-icons/fi';
import { BiMessageError, BiMessageCheck, BiMessageX } from 'react-icons/bi';
import { Bar, HorizontalBar,Line, Pie } from 'react-chartjs-2';
import { fill } from 'lodash';
import { Table } from 'react-bootstrap';
import { Container } from 'react-bootstrap/lib/Tab';
import Filter from './Filter';
import { BarItems } from '../../layout/styles';
import Button from './Button';
import { InsightWrapper } from '../../../../screens/reporting/styles';
import BreadCrumb from './breadcrumb/BreadCrumb';
import { withRouter } from 'react-router';
import moment from 'moment-timezone';

export class DashboardTheme extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();

    let zone = {};
    var timeZone = moment.tz.guess();
    zone.value = timeZone;
    zone.label = zone.value;
    if (window.localStorage && window.localStorage.getItem('timezone')) {
      zone = JSON.parse(window.localStorage.getItem('timezone'));
    }
    if (zone === null) {
      timeZone = moment.tz.guess();
      zone = {};
      zone.value = timeZone;
      zone.label = zone.value;
    }
    this.currentTimestamp =
      parseInt(
        moment()
          .tz(zone.value)
          .format('X')
      ) * 1000;
    

    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.getData = this.getData.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.open = this.open.bind(this);

    this.state = {
      endDate: this.currentTimestamp,
      // startDate: dayBeforeTimeStamp,
      // selectedProjects: [],
      // columnList: defaultColums,
      // selectedColumList: selectedColumList,
      startDate: this.currentTimestamp,

      showNoDataAvailable: true,
      isActive: false,
      reportData: [],
      totalPerPage: 0,
      perPageCount: 10,
      currentPage: 1,
      loading: true,
      smsTableData: [
        {
          index: 1,
          title: "Pending",
          count: 0
        },
        {
          index: 2,
          title: "Delivered",
          count: 0
        },
        {
          index: 3,
          title: "Expired",
          count: 0
        },
        {
          index: 4,
          title: "Undelivered",
          count: 0
        }
      ],
      dashboardTile: [
        {title: "Submission SMS", count: 0, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px", color:"blue"}} />},
        {title: "Delivered SMS", count: 0, isSecs: false, icon: <BiMessageCheck style={{fontSize: "25px", color:"green"}} />},
        {title: "Pending SMS", count: 0, isSecs: false, icon: <BiMessageError style={{fontSize: "25px", color:"orange"}} />},
        {title: "Failed SMS", count: 0, isSecs: false, icon: <BiMessageX style={{fontSize: "25px", color:"red"}} />}
      ],
      dashboardSentGraph: this.generateGraph({
        labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
        data : [
          {
            label: 'SMS Analysis',
            data: [0,0,0,0,0,0],
            backgroundColor: [
              '#2B70A7',
              '#BF1E2E',
              '#EF4136',
              '#F15A2B',
              '#E2B37D'
          ],
          },
           
        ]
      }),
      dashboardSummary: [
        
      ],
      dashboardMonthlySummary: this.generateGraph({
        labels: ["Januaray","February", "March", "April", "May", "June"],
        data : [
          {
            label: 'Delivered',
            data: [2,4,9,0,1,0],
            backgroundColor: '#2b78a2'
          },
          {
            label: 'Undelivered',
            data: [2,0,1,0,1,0],
            backgroundColor: '#6ea8c9'
          },{
            label: 'Rejected',
            data: [1,0,9,0,1,0],
            backgroundColor: '#b6dee7'
          
          },{
            label: 'Pending',
            data: [2,4,3,0,1,0],
            backgroundColor: '#f2cdaf'
          },
          {
            label: 'Expired',
            data: [2,1,3,5,0,0],
            backgroundColor: '#f9e2cf'
          },
        ]
      }),
      dashboardHourlySummary: [

      ]
    };
    
    this.handleFireAPI();

  }


  getData(data) {
    console.log("dashboard data",data);
    let filter = {
      "date": data.startDate || "",
      // "sendEndTime": data.endDate || "",
      // "timezone": data.timezone || {},
      "fromDate": data.startDate || "",
      "toDate": data.endDate || "",
      "sender": data.selectedSenderList ? data.selectedSenderList.value : "",
      // "to": data.toSelector || "",
      // "freeTextSearch": data.freeTextSearch || "",
    }
    console.log("filter data",filter);
    this.setState({ "Filters": filter })
    // this.getList(1, this.state.perPageCount, filter)
    // this.downloadReport(1, this.state.perPageCount, filter)
    this.handleFireAPI(filter);
  }

  handleFireAPI(filter="") {
    this.setState({ loading: true });
    console.log(`Dashboard URL ->`);
    filter = filter==="" || filter.date === "" || filter.selectedSenderList === "" ?  {date: this.state.startDate, fromDate: this.state.startDate, toDate: this.state.startDate} : filter;

    let tData = {
      ...filter,
      
    }
    this.mAPI.sendPostAPI(
      `sms/api/v1/dashboard/sms`,
      filter,
      data => {
        this.setState({ loading: false });
        if(data) {
           console.log(data);
           let tileData = data.dlrStatus;
           let dashboardTile = [
            {title: "Submission SMS", count: data.submission_sms || 0, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px", color:"blue"}} />},
            {title: "Delivered SMS", count: tileData.DELIVRD || 0, isSecs: false, icon: <BiMessageCheck style={{fontSize: "25px", color:"green"}} />},
            {title: "Pending SMS", count: tileData.PENDING || 0, isSecs: false, icon: <BiMessageError style={{fontSize: "25px", color:"orange"}} />},
            {title: "Failed SMS", count: tileData.UNDELIV || 0, isSecs: false, icon: <BiMessageX style={{fontSize: "25px", color:"red"}} />},
          ]
          //  let dashboardTile = tileData.map(callStatus => (
          //   { title: callStatus.dlrStatus.charAt(0).toUpperCase()+ callStatus.dlrStatus.slice(1).toLowerCase(), count: callStatus.countDlrStatus, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px"}} /> }
          //  ))
           let gLabels = Object.keys(tileData) || [];
           let gData = gLabels.map(callData => tileData[callData]) || [];
           this.setState({
            showNoDataAvailable: gData.every(count => count===0),
            smsTableData: dashboardTile,
            dashboardTile: dashboardTile,
            dashboardSentGraph: this.generateGraph({
              labels: gLabels,
              data: [
                {
                  data: gData,
               backgroundColor: [
                "#c1e7ff", "#9dc6e0", "#7aa6c2", "#5886a5", "#346888"
              ],
                 
               
              // backgroundColor: [
              //   "#daf1de", "#d6e9aa", "#aee6cb", "#85d4be", "#96dfd8"
              // ],
              //   backgroundColor: [
              //     "#287f8e", "#c0b65a", "#a6d2d4", "#e06547", "#b2b7bf"
              // ]
              //   backgroundColor: [
              //     "#fd5901", "#f78104", "#faab36", "#249ea0", "#008083"
              // ],
              //   backgroundColor: [
              //     '#2085ec',
              //     '#58508D',
              //     '#BC5090',
              //     '#FF6361',
              //     '#FFA600'
              // ],
              //   backgroundColor: [
              //     '#cea9bc',
              //     '#2085ec',
              //     '#28AAE1',
              //     '#8464a0',
              //     '#F15A2B'
              // ],
                borderWidth: 0
                },
              ]
            }),
            dashboardSummary: this.generateGraph({
              labels: gLabels,
              data: [
                {
                  label: "SMS Analysis",
                  data: gData,
                  backgroundColor: [
                    // '#d5e9f4',
                    // "#2f4f75",
                    // '#99bddf',
                    // '#9a9cc2',
                    // '#feb78d',
                    "#745CB8", "#2196F3", "#D4455", "#FFAB91", "#D84315",
                    // '#fdcfbb',
                    // '#ff97A5',
                    // '#fcd353',
                    // '#feb78d',
                    // '#fd8b64'
                ]
                },
                 
              ]
            }),
            dashboardHourlySummary: this.generateGraph({
              labels: gLabels,
              data: [
                {
                  label: "Hourly SMS",
                  data: gData,
                  backgroundColor: "#99bddf",
                  borderColor: "#2f4f75"
                },
                 
              ]
            })
           })
           console.log(dashboardTile);
        }
        else{ 
          console.log("no data");
          this.setState({
            smsTableData: [
              {
                index: 1,
                title: "Pending",
                count: 0
              },
              {
                index: 2,
                title: "Delivered",
                count: 0
              },
              {
                index: 3,
                title: "Expired",
                count: 0
              },
              {
                index: 4,
                title: "Undelivered",
                count: 0
              }
            ],
            dashboardTile: [
              {title: "Submission SMS", count: 0, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px"}} />},
            {title: "Delivered SMS", count: 0, isSecs: false, icon: <BiMessageCheck style={{fontSize: "25px"}} />},
            {title: "Pending SMS", count: 0, isSecs: false, icon: <BiMessageError style={{fontSize: "25px"}} />},
            {title: "Failed SMS", count: 0, isSecs: false, icon: <BiMessageX style={{fontSize: "25px"}} />}
          ],
            dashboardSentGraph: this.generateGraph({
              labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
              data : [
                {
                  label: 'SMS Analysis',
                  data: [0,0,0,0,0,0],
                  backgroundColor: [
                    '#72b4eb',
                    '#2085ec',
                    '#28AAE1',
                    '#7aa6c2',
                    '#F15A2B'
                ]
                },
                 
              ]
            }),
            dashboardSummary: this.generateGraph({
              labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
              datasets: [
                {
                  label: 'SMS Analysis',
                  data: [0,0,0,0,0,0],
                  backgroundColor: [
                    '#72b4eb',
                    '#2085ec',
                    '#28AAE1',
                    '#7aa6c2',
                    '#F15A2B'
                ]
                },
                 
              ]
            })
          })
          
        }
        // if (data && data.data) {
        //   // that.setState({ listData: data.data, total: data.count || 0 });
        // }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.error(` ${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      },
      "public"
    );
  }

  generateGraph(cData) {
    let tData = {
      labels: cData.labels,
      plot: {
        animation: {
          sequence: 3,
          effect: 4,
          method: 1,
          speed: 500
        }
      },
      datasets: []
    };
    if ( cData.data ){
      cData.data.forEach(element => {
        let datasets = {
          label: element.label || "none",
          fill: true,
          lineTension: element.lineTension || 0.1,
          backgroundColor: element.backgroundColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)'

          ],
          // borderColor: element.borderColor || [
          //   'rgb(26, 35, 126)',
          //   'rgb(48, 63, 159)',
          //   'rgb(63, 81, 181)',
          //   'rgb(121, 134, 203)',
          //   'rgb(197, 202, 233)',
          //   'rgb(232, 234, 246)'
          // ],
          // borderCapStyle: element.borderCapStyle || 'butt',
          // borderDash: element.borderDash || [],
          // borderDashOffset: element.borderDashOffset || 0.0,
          // borderJoinStyle: element.borderJoinStyle || 'miter',
          // pointBorderColor: element.pointBorderColor || '#4D528E',
          pointBackgroundColor: element.pointBackgroundColor || '#fff',
          pointBorderWidth: element.pointBorderWidth || 1,
          pointHoverRadius: element.pointHoverRadius || 5,
          pointHoverBackgroundColor: element.pointHoverBackgroundColor || '#4D528E',
          pointHoverBorderColor: element.pointHoverBorderColor || '#4D528E',
          pointHoverBorderWidth: element.pointHoverBorderWidth || 2,
          pointRadius: element.pointRadius || 1,
          pointHitRadius: element.pointHitRadius || 10,
          data: element.data || []
        }
        tData.datasets.push(datasets);
      });
    }
    return tData;
  }

  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle>
        {__(title)}
      </InsightTitle>
    );
  }


  getSelectedColumnNames() {
    return [];
  }

  // open
  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }
  renderContent() {
    const { brands, history, queryParams } = this.props;
    return (
      <InsightWrapper>
        {/* <span> */}
        <InsightRow style={{ marginTop: '14px' }}>
              <Filter 
              filterList={["renderSender"]}
              getData={this.getData}
              history={history}
              getSelectedColumnNames={this.getSelectedColumnNames}
              />
            
          </InsightRow>
          
        {/* </span> */}
      </InsightWrapper>

    );
  }
  render() {
    const { __ } = this.context;
    const breadcrumb = [{ title: __('Dashboard'), link: '/dashboard' }];
    const { brands, history, queryParams } = this.props;

    const options = {
      // maintainAspectRatio : false,
      elements: {
        arc: {
          borderWidth: 1
        }
      },
      legend: {
        position: 'right',
        labels: {
          boxWidth: 10
        }
      }
    };
   const barChartOptions = {
    // maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: true
        },
        gridLines: {
          display:false
        },
      }],
      yAxes:[{
        gridLines: {
          display:false
      },
        barThickness: 15,
        grid: {
          drawOnChartArea: false, // only want the grid lines for one axis to show up
        },
      }]
    }  
    };
    const stackedChartOptions = {
      scales: {
        xAxes: [{
            stacked: true,
            gridLines: {
              display:false
          }
        },],
        yAxes: [{
            stacked: true,gridLines: {
              display:false
          }
        }],
    }
    };
    const actionBarRight = (
      <BarItems>

        <Button
          btnStyle="filter"
          size="small"
          onClick={() => this.open()}
        >
          <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
        </Button>
        {/* <Dropdown id="dropdown-engage" pullRight >
          <DropdownToggle bsRole="toggle">
            <Button
              btnStyle="filter"
              size="small"
            >
              <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
            </Button>
          </DropdownToggle>
          <Dropdown.Menu>
            <li>
              <a>
                {__('Campaign')}
              </a>
            </li>
            <li>
              <a>
                {__('Process')}
              </a>
            </li>
          </Dropdown.Menu>
        </Dropdown> */}
      </BarItems>
    );

    const SMSTable = (
      <Table striped hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Delivery Status</th>
            <th>Message Count</th>
          </tr>
        </thead>
        <tbody id="SMS">
          {this.state.smsTableData.map((data, index) => (
            <tr key={index}>
              <td>{index}</td>
              <td>{data.title}</td>
              <td>{data.count}</td>
            </tr>
          ))}
        </tbody>
      
      </Table>
    );
    
    const contentData = (
      
      <div>
        <InsightContent>
          {/* <FlexRow>
            <DashboardTileTheme
              loading={false}
              data={this.state.dashboardTile}
              options={options}
            />
          </FlexRow> */}
          <InsightRow>
              {/* <LiveMonitorTileTheme
                loading={false}
                data={this.state.dashboardTile}
                options={options}
              /> */}
              {/* <LiveMonitorTileDataTheme
              loading={false}
              data={this.state.dashboardTile}
              options={options}
              />*/}
          </InsightRow>
          
          <InsightRow style={{ marginTop: '14px' }}>
            <FlexRow>
              <ChartWrapper height={300} style={{marginRight: "10px", marginBottom:"10px"}}>
                {this.renderTitle('SMS Analysis')}
                {this.state.showNoDataAvailable ? <p style={{textAlign: "center"}}>No Data Available</p> : <Pie
                width={215}
                height={"98%"}
                ref="chart"
                data={this.state.dashboardSentGraph}
                options={options}
                /> }
                
              </ChartWrapper>

              <ChartWrapper height={300} style={{marginRight: "10px", marginBottom:"10px"}}>
                {this.renderTitle('Summary Report')}
                {/* {SMSTable} */}
                {this.state.showNoDataAvailable ? <p style={{textAlign: "center"}}>No Data Available</p> : <HorizontalBar 
                ref="chart" 
                data={this.state.dashboardSummary} 
                options={barChartOptions} 
                height={"140px"}/>}
              
              </ChartWrapper>

              <ChartWrapper height={300} style={{marginBottom:"10px"}}>
                {this.renderTitle('Summary Report')}
                {this.state.showNoDataAvailable ? <p style={{textAlign: "center"}}>No Data Available</p> : <HorizontalBar 
                ref="chart" 
                data={this.state.dashboardSummary} 
                options={barChartOptions} 
                height={"140px"}/>}
              
              </ChartWrapper>
            </FlexRow>
          </InsightRow>
          <InsightRow style={{ marginBottom: '14px' }}>
            <FlexRow>
              <ChartWrapper height={400} style={{marginRight: "10px", marginBottom:"10px"}}>
                {this.renderTitle('Monthly Report')}
                {this.state.showNoDataAvailable ? <p style={{textAlign: "center"}}>No Data Available</p> : <Bar
                // width={215}
                // height={"92%"}
                ref="chart"
                data={this.state.dashboardMonthlySummary}
                options={stackedChartOptions}
                />}
                
              </ChartWrapper>
              
              <ChartWrapper height={400} style={{marginBottom:"10px"}}>
                {this.renderTitle('Hourly Report')}
                {/* {SMSTable} */}
                {this.state.showNoDataAvailable ? <p style={{textAlign: "center"}}>No Data Available</p> : <Line ref="chart" 
                data={this.state.dashboardHourlySummary} 
                options={stackedChartOptions}/>}
              </ChartWrapper>
            </FlexRow>
          </InsightRow>
        </InsightContent>
      </div>
    );
    const content = (
      <div>
        <InsightContent>
          <FlexRow>

          </FlexRow>
        </InsightContent>
      </div>
    );
    return (
      <div>
        {this.state.isActive && <WrapperData content={this.renderContent()} overflow={true} />}

        <WrapperData
          actionBar={
            <WrapperData.ActionBar
              left={
                <BreadCrumb breadcrumbs={breadcrumb} />
                
              }
              right={actionBarRight}
            />
          }
          content={content}
          style={{ overflow: "hidden" }}
          transparent={true}
        />

        <WrapperData
          // header={<Wrapper.Header breadcrumb={breadcrumb} />}
          content={contentData}
          style={{ overflow: "hidden" }}
          transparent={true}
        />
      </div>
    );
  }
}

DashboardTheme.contextTypes = {
  __: PropTypes.func
};

export default withRouter(DashboardTheme);



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/DashboardTheme.js